/**
 * The dialog manager object provides functions to interact
 * with a HTMLDialogElement to ensure the wanted beavior
 */
const dialogManager = {

	originalScrollPosition: 0,

	showDialog: ( dialogElement: HTMLDialogElement ): void => {
		if ( !dialogElement ) {
			throw new Error( 'Dialog element is null.' );
		}

		if ( dialogElement.open ) return dialogManager.closeDialog( dialogElement );

		const countOpenDialogs = document.querySelectorAll( 'dialog[open]' ).length;

		if ( countOpenDialogs < 1 ) dialogManager.originalScrollPosition = document.documentElement.scrollTop;
		document.documentElement.scrollTo( { top: 0, behavior: "instant" } );

		const closeOtherDialogs = () => {
			const allDialogs = document.querySelectorAll( 'dialog' );
			for ( const aDialog of allDialogs ) {
				dialogManager.closeDialog( aDialog );
			}
		};
		closeOtherDialogs();


		if ( dialogElement.dataset.dialogName !== '' ) {
			const dialogOpenButtons = document.querySelectorAll(
				`button[data-dialog-open="${dialogElement.dataset.dialogName}"]`,
			);

			for ( const button of dialogOpenButtons ) {
				( button as HTMLElement ).dataset.active = 'true';
			}
		}

		document.body.classList.add( 'overflow-hidden' );
		document.body.classList.add( 'fixed' );
		document.body.style.setProperty( '--ufr-dialog-global-margin-top', `-${dialogManager.originalScrollPosition}px` );
		document.body.classList.add( 'mt-[var(--ufr-dialog-global-margin-top,0px)]' );
		document.body.classList.add( 'w-full' );
		dialogElement.removeAttribute( 'inert' );
		if ( dialogElement.dataset.dialogType !== 'modal' ) {
			dialogElement.style.setProperty( '--ufr-dialog-element-margin-top', `${dialogManager.originalScrollPosition}px` );
			dialogElement.classList.add( 'mt-[var(--ufr-dialog-element-margin-top,0px)]' );
		}

		if ( ! dialogElement.open ) {
			/**
			 * by default, treat it as a dialog, not a modal window and
			 * therefore open it with show() instead of showModal().
			 *
			 * The possible values for the dialogType attribute are:
			 * - modal
			 * - dialog
			 *
			 * So if they have set none or an invalid value, it will be treated as a dialog.
			 */
			dialogElement.dataset.dialogType === 'modal' ? dialogElement.showModal() : dialogElement.show();
		}
	},
	closeDialog: ( dialogElement: HTMLDialogElement ): void => {
		if ( !dialogElement ) {
			throw new Error( 'Dialog element is null.' );
		}

		if ( dialogElement.dataset.dialogName !== '' ) {
			const dialogOpenButtons = document.querySelectorAll(
				`button[data-dialog-open="${dialogElement.dataset.dialogName}"]`,
			);
			for ( const button of dialogOpenButtons ) {
				( button as HTMLElement ).dataset.active = 'false';
			}
		}

		dialogElement.setAttribute( 'inert', '1' );
		dialogElement.style.removeProperty( '--ufr-dialog-element-margin-top' );

		// If this dialog is the last open dialog, remove overflow-hidden from the body.
		const countOpenDialogs = document.querySelectorAll( 'dialog[open]' ).length;
		if ( countOpenDialogs <= 1 ) {
			document.body.classList.remove( 'overflow-hidden' );
			document.body.classList.remove( 'fixed' );
			document.body.classList.remove( 'mt-[var(--ufr-dialog-global-margin-top,0px)]' );
			document.body.style.removeProperty( '--ufr-dialog-global-margin-top' );
			document.body.classList.remove( 'w-full' );
			document.documentElement.scrollTo( { top: dialogManager.originalScrollPosition, behavior: "instant" } );
		}

		if ( dialogElement.open ) {
			dialogElement.close();
		}
	},
};

document.addEventListener( 'openDialog', ( ev: CustomEvent ) => {
	const dialogElement = document.querySelector(
		`[data-dialog-name="${ev.detail.dialogName}"]`,
	) as HTMLDialogElement | null;

	if ( !dialogElement ) {
		throw new Error( 'Dialog element is null.' );
	}

	dialogManager.showDialog( dialogElement );
} );

document.addEventListener( 'closeDialog', ( ev: CustomEvent ) => {
	const dialogElement = document.querySelector(
		`[data-dialog-name="${ev.detail.dialogName}"]`,
	) as HTMLDialogElement | null;

	if ( !dialogElement ) {
		throw new Error( 'Dialog element is null.' );
	}

	dialogManager.closeDialog( dialogElement );
} );

( () => {
	const dialogCloseButtons = document.querySelectorAll(
		'[data-action="closeDialog"]' ) as NodeListOf<HTMLButtonElement>;

	dialogCloseButtons.forEach( ( button ) => {

		button.addEventListener( 'click', () => {

			document.dispatchEvent( new CustomEvent( 'closeDialog', {
				detail: {
					dialogName: button.dataset.dialogClose,
				},
			} ) );

		} );

	} );
} )();


( () => {
	const dialogOpenButtons = document.querySelectorAll(
		'[data-action="openDialog"]' ) as NodeListOf<HTMLButtonElement>;

	dialogOpenButtons.forEach( ( button ) => {

		button.addEventListener( 'click', () => {

			document.dispatchEvent( new CustomEvent( 'openDialog', {
				detail: {
					dialogName: button.dataset.dialogOpen,
				},
			} ) );

		} );

	} );

} )();



export default dialogManager;
